import React from 'react';
import { LaneLayout } from './layout';
import { withAlpha } from '../../services/color';
import { ETLane } from './types';
import { timelineColors, timelineFontWeight } from './tokens';

export const LANE_LABEL_COLUMN_INSET = 14;

// Vertical padding the lane tint band + label cell extend above and below each
// lane row. The band below the last lane hangs this far past the packed lane
// height, so the canvas must reserve it too (see `totalHeight` in index.tsx).
export const LANE_BAND_VPAD = 4;

// Renders both the sticky-left label cell (with the collapse chevron) and
// the lane's tinted background band. Kept as one component since they're
// one visual row conceptually.
export const LaneLabels = React.memo(
  ({
    lanes,
    laneById,
    labelWidth,
    canvasWidth,
    onToggleLane
  }: {
    lanes: ETLane[];
    laneById: Record<string, LaneLayout>;
    labelWidth: number;
    canvasWidth: number;
    onToggleLane: (laneId: string) => void;
  }) => (
    <>
      {lanes.map((lane) => {
        const rect = laneById[lane.id];
        if (!rect) return null;
        return (
          <React.Fragment key={lane.id}>
            <div
              style={{
                position: 'absolute',
                left: labelWidth,
                top: rect.top - LANE_BAND_VPAD,
                width: canvasWidth - labelWidth,
                height: rect.height + LANE_BAND_VPAD * 2,
                background: withAlpha(lane.color, '1A'),
                borderRadius: 4,
                zIndex: 0
              }}
            />
            {/* TODO(Phase 2): make this genuinely sticky-left once this
                mounts inside the real app's scroll container — that needs a
                two-region layout (fixed label pane + independently
                horizontally-scrolling grid pane) rather than everything
                living in one absolutely-positioned canvas as it does here. */}
            <div
              onClick={rect.collapsible ? () => onToggleLane(lane.id) : undefined}
              style={{
                position: 'absolute',
                left: 0,
                top: rect.top - LANE_BAND_VPAD,
                width: labelWidth - LANE_LABEL_COLUMN_INSET,
                height: rect.height + LANE_BAND_VPAD * 2,
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                fontSize: 12,
                fontWeight: timelineFontWeight.medium,
                color: timelineColors.ink,
                cursor: rect.collapsible ? 'pointer' : 'default',
                userSelect: 'none',
                zIndex: 2,
                background: timelineColors.surface
              }}
            >
              {rect.collapsible ? (
                <span
                  style={{
                    display: 'inline-flex',
                    width: 12,
                    height: 12,
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: timelineColors.textSubtle,
                    fontSize: 10,
                    transform: rect.collapsed ? 'rotate(-90deg)' : 'none',
                    transition: 'transform 120ms ease',
                    flexShrink: 0
                  }}
                >
                  ▾
                </span>
              ) : (
                <span style={{ width: 12, flexShrink: 0 }} />
              )}
              {lane.label}
            </div>
          </React.Fragment>
        );
      })}
    </>
  )
);
